module.exports = __webpack_public_path__ + "img/mask.04ed958a.png";